const variadicKeyResolver = (...args) => args.join('##');

export default variadicKeyResolver;
